import { ApolloError } from '@apollo/client/errors';

import { useRealmFeatureTogglesQueryRemote, useUserFeatureTogglesQueryRemote } from '@/store/v2';

export type FeatureToggles = string[];

/**
 * Fetch realm specific public feature toggles
 * @param realm
 */
export const useRealmFeatureToggles = (
  realm: string,
  isLoggedIn: boolean,
): {
  data: FeatureToggles;
  loading: boolean;
  error?: ApolloError;
} => {
  const { data, loading, error } = useRealmFeatureTogglesQueryRemote({
    variables: { realm },
    skip: !!isLoggedIn,
  });

  return {
    data: (data?.realmFeatureToggles ?? []).map(({ name }) => name),
    loading,
    error,
  };
};

/**
 * Fetch user specific feature toggles
 * @param realm
 */
export const useUserFeatureToggles = (
  realm: string,
  isLoggedIn: boolean,
): {
  data: FeatureToggles;
  loading: boolean;
  error?: ApolloError;
} => {
  const { data, loading, error } = useUserFeatureTogglesQueryRemote({
    variables: { realm },
    skip: !isLoggedIn,
  });

  return {
    data: (data?.getCurrentUserFeatureToggles ?? []).map(({ name }) => name),
    loading,
    error,
  };
};
